export const changedPicture = (data) => {
    return async (dispatch) => {
        await dispatch({type:"CHANGE_PIC",payload:data})
    }
}